import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TemplateEditor } from '../../../../components/templateEditor';
import { useStyles } from '../styles';
import TemplateRow from './templateRow';
import { combineClasses } from '../../../../utils/styling';
import { positionTypes } from '../../../../utils/constants';

export const Templates = props => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [dialogObject, setDialogObject] = useState({ isOpen: false });
  const [positionType, setPositionType] = useState();

  useEffect(() => {
    setPositionType(null);
  }, [props.refreshDialog]);

  const editTemplate = useCallback((pt, dObject) => {
    setPositionType(pt);
    setDialogObject({
      ...dObject,
      templateSaved: savedTemplate => {
        dObject.templateSaved.bind(dObject.scope)(savedTemplate);
        setDialogObject({ isOpen: false });
      },
    });
  }, []);

  return (
    <>
      <TemplateEditor
        positionType={positionType}
        dialogObject={dialogObject}
        closeDialog={() => setDialogObject({ isOpen: false })}
      />
      <Grid item container xs={2} justifyContent="center">
        <label
          className={combineClasses([
            classes.Bold,
            classes.Required,
            classes.UpperCase,
          ])}
        >
          {t('positionTemplate.positionType')}
        </label>
      </Grid>
      <Grid item container xs={8}>
        <label
          className={combineClasses([
            classes.Bold,
            classes.Required,
            classes.UpperCase,
          ])}
        >
          {t('positionPage.templates')}
        </label>
      </Grid>
      <Grid item xs={2} />
      {positionTypes.map(pt => (
        <TemplateRow key={pt} positionType={pt} editTemplate={editTemplate} />
      ))}
    </>
  );
};

Templates.propTypes = {
  refreshDialog: PropTypes.number,
};
